module.exports = __webpack_public_path__ + "static/img/米堤.8ba936e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/建置實績/米堤.png?20181011
// module id = vutv
// module chunks = 1